import { Component, OnInit, Input } from '@angular/core';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SparepartsService } from '../../../service/spareparts.service';
// import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SpareListComponent } from '../../spareparts-management/spare-list/spare-list.component';

@Component({
  selector: 'app-take-spare-detail',
  templateUrl: './take-spare-detail.component.html',
  styleUrls: ['./take-spare-detail.component.less']
})
export class TakeSpareDetailComponent implements OnInit {


  validateForm: FormGroup;
  selectedValue: string;
  listOfData: ItemData[] = [];
  editId: string | null = null;
  jobNo: string;
  @Input() takeSpareNo: string;
  @Input() missionNo: string;
  @Input() description: string;
  @Input() flag: number; // 新创建领料单 flag = 1
  uploading = false;
  loading = false;
  canSave = false;
  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private modal: NzModalService,
    public message: NzMessageService,
    private dataService: SparepartsService
  ) { }

  ngOnInit(): void {
    if (this.takeSpareNo != null) {
      if (this.flag === 0) {
        this.canSave = true;
        this.validateForm = this.fb.group({
          takeSpareNo: new FormControl({ value: this.takeSpareNo, disabled: true }, Validators.required),
          missionNo: new FormControl({ value: this.missionNo, disabled: true }, Validators.required)
        });
      } else {
        this.canSave = false;
        this.validateForm = this.fb.group({
          takeSpareNo: new FormControl({ value: this.takeSpareNo, disabled: false }, Validators.required),
          missionNo: new FormControl({ value: this.missionNo, disabled: false }, Validators.required)
        });
      }
      this.queryTakeSpareDetailData();
    } else {
      this.validateForm = this.fb.group({
        takeSpareNo: new FormControl({ value: null, disabled: false }, Validators.required),
        missionNo: new FormControl({ value: null, disabled: false }, Validators.required)
      });
      // this.initEntryNo();
    }
    // 工单编号设置为不可编辑
    this.validateForm.controls.missionNo.disable();
  }
  initEntryNo() {
    const nowstr = new Date();
    this.takeSpareNo = nowstr.getFullYear()
      + ((nowstr.getMonth() + 1) < 10 ? '0' : '') + (nowstr.getMonth() + 1)
      + (nowstr.getDate() < 10 ? '0' : '') + nowstr.getDate()
      + (nowstr.getHours() < 10 ? '0' : '') + nowstr.getHours()
      + (nowstr.getMinutes() < 10 ? '0' : '') + nowstr.getMinutes()
      + (nowstr.getSeconds() < 10 ? '0' : '') + nowstr.getSeconds();
  }

  async queryTakeSpareDetailData() {
    this.loading = true;
    const result = await this.dataService.queryTakeSpareDetailData(this.takeSpareNo);
    this.loading = false;
    if (result === null) {
      this.message.create('error', '领料单详情查询失败!');
      return;
    } else {
      result.list.forEach(element => {
        element.total = element.price * element.amount;
      });
      this.listOfData = result.list;
    }
  }
  addSpare() {
    const modal = this.modal.create({
      nzTitle: '备件列表',
      nzContent: SpareListComponent,
      nzStyle: { top: '40px' },
      nzWidth: 800,
      nzMaskClosable: false,
      nzFooter: null,
      nzComponentParams: {
        code: 1, // code 0 备件只能查看，不能选择 code 1 备件可以查看 也可以被选中
      }
    });
    modal.afterClose.subscribe(
      {
        next: items => {
          // console.log(items);
          if (items != null && items !== undefined) {
            items.forEach(element => {
              const index = this.listOfData.findIndex((a) => a.spNo === element.spNo);
              if (index < 0) {
                this.listOfData = [
                  ...this.listOfData,
                  {
                    spNo: element.spNo,
                    spName: element.spName,
                    amount: 0,
                    stocks: element.amount,
                    price: element.price,
                    unit: element.unit,
                    total: 0,
                    desc: element.mark,
                    rldNo: null,
                    rlNo: null
                  }
                ];
              }
            });
          }

        }
      }
    );
  }
  exportForm() {
    if (this.listOfData == null || this.listOfData.length === 0) {
      return;
    }
    const dataToExport: any[] = [];
    let index = 0;
    this.listOfData.forEach(e => {
      index = index + 1;
      const item = {
        '序号': index,
        '备件名称': e.spName,
        '数量': e.amount,
        '单位': e.unit,
        '备注': e.desc
      };
      dataToExport.push(item);
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { '领料单': worksheet }, SheetNames: ['领料单'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    const nowstr = new Date();
    const datenow = nowstr.getFullYear()
      + ((nowstr.getMonth() + 1) < 10 ? '0' : '') + (nowstr.getMonth() + 1)
      + (nowstr.getDate() < 10 ? '0' : '') + nowstr.getDate()
      + (nowstr.getHours() < 10 ? '0' : '') + nowstr.getHours()
      + (nowstr.getMinutes() < 10 ? '0' : '') + nowstr.getMinutes()
      + (nowstr.getSeconds() < 10 ? '0' : '') + nowstr.getSeconds();
    // FileSaver.saveAs(data, this.takeSpareNo == null ? '领料单' + '_' + datenow + '.xlsx' : '领料单' + this.takeSpareNo + '_' + datenow + '.xlsx');
  }
  deleteRow(id: number): void {
    this.listOfData = this.listOfData.filter(d => d.spNo !== id);
  }
  startEdit(id: string): void {
    this.editId = id;
  }

  stopEdit(data: any): void {
    if (data.amount < 0) {
      data.amount = 0;
    }
    data.total = data.amount * data.price;
    this.editId = null;
  }
  cancleTakeSpareData() {
    this.modalRef.destroy('cancle');
  }
  /**
   * 保存领料单
   */
  async saveTakeSpareData() {
    if (this.missionNo == null || this.missionNo === undefined || this.missionNo.toString().trim() === '') {
      this.message.create('warning', '请输入工单编号!');
      return;
    }
    if (this.listOfData == null || this.listOfData.length === 0) {
      this.message.create('warning', '请添加备件信息!');
      return;
    }
    if (!this.listOfData.every(data => data.amount > 0)) {
      this.message.create('warning', '申请备件数量不能等于0!');
      return;
    }

    if (!this.listOfData.every(data => data.amount <= data.stocks)) {
      this.message.create('warning', '申请备件数量不能大于当前库存数量!');
      return;
    }

    if (!this.listOfData.every(data => (data.desc == null || data.desc === undefined || data.desc.trim().length <= 50))) {
      this.message.create('warning', '备件的备注信息字数不能大于50!');
      return;
    }
    if (this.description != null && this.description !== undefined && this.description.trim().length > 100) {
      this.message.create('warning', '领料单备注信息字数不能大于100!');
      return;
    }
    if (this.description === undefined || this.description == null) {
      this.description = '';
    }
    const info = this.takeSpareNo == null ? '确认领料备件数量等信息无误并创建领料单？' : '确认领料备件数量等信息无误并保存领料单？';
    this.modal.confirm({
      nzTitle: '<i>' + info + '</i>',
      // nzContent: '<b>保存？</b>',
      nzOnOk: () => this.saveTakeSpareDataInfo()
    });
  }
  async saveTakeSpareDataInfo() {
    this.uploading = true;
    const result =
      await this.dataService.uploadTakeSparePartsData(this.takeSpareNo, this.missionNo, this.listOfData, this.description);

    this.uploading = false;
    if (result.code !== 200) {
      this.message.create('error', result.msg);
    } else {
      this.message.create('success', this.takeSpareNo == null ? '创建领料单成功!' : '修改领料单成功!');
      this.modalRef.destroy('success');
    }
  }
}
interface ItemData {
  spNo: number;
  spName: string;
  amount: number;
  unit: string;
  price: number;
  total: number;
  desc: string;
  stocks: number;
  rldNo: number;
  rlNo: number;
}
